// components/Chat/LoadingMessage.js
import React, { useState, useEffect } from 'react';

// Static messages array moved outside component to avoid dependency issues
const LOADING_MESSAGES = [
    'Processing your question',
    'Gathering relevant information',
    'Structuring the explanation',
    'Preparing comprehensive answer',
    'Organizing key concepts',
    'Analyzing your request',
    'Thinking through the details',
    'Formulating response',
    'Reviewing available data',
    'Considering multiple perspectives',
    'Generating insights',
    'Connecting related information',
    'Working on your query',
    'Processing information',
    'Crafting detailed response',
    'Evaluating context',
    'Synthesizing knowledge',
    'Building comprehensive answer'
];

const LoadingMessage = () => {
    const [currentMessage, setCurrentMessage] = useState('');
    const [dots, setDots] = useState('');
    const [animationKey, setAnimationKey] = useState(0);

    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            margin: '4px 0'
        },
        text: {
            fontSize: '0.875rem',
            color: '#6c757d',
            marginLeft: '8px',
            animation: 'slideFromBottom 0.5s ease-out forwards',
            opacity: 0,
            transform: 'translateY(10px)'
        }
    };

    // Single effect for all animations and message cycling
    useEffect(() => {
        // Inject keyframes once
        if (!document.querySelector('#loading-keyframes')) {
            const style = document.createElement('style');
            style.id = 'loading-keyframes';
            style.textContent = `
                @keyframes slideFromBottom {
                    to { opacity: 1; transform: translateY(0); }
                }
            `;
            document.head.appendChild(style);
        }

        // Set initial message
        setCurrentMessage(LOADING_MESSAGES[0]);
        let lastIndex = 0;

        // Animate dots
        const dotInterval = setInterval(() => {
            setDots(prev => prev.length >= 3 ? '' : prev + '.');
        }, 500);

        // Cycle messages randomly
        const messageInterval = setInterval(() => {
            let nextIndex;
            do {
                nextIndex = Math.floor(Math.random() * LOADING_MESSAGES.length);
            } while (nextIndex === lastIndex && LOADING_MESSAGES.length > 1);

            lastIndex = nextIndex;
            setCurrentMessage(LOADING_MESSAGES[nextIndex]);
            setAnimationKey(prev => prev + 1);
        }, 3000);

        return () => {
            clearInterval(dotInterval);
            clearInterval(messageInterval);
        };
    }, []); // Now ESLint won't complain about missing dependencies

    return (
        <div style={styles.container}>
            <div
                className="spinner-grow spinner-grow-sm"
                role="status"
                style={{ width: '0.8rem', height: '0.8rem' }}
            >
                <span className="visually-hidden">Loading...</span>
            </div>
            <span key={animationKey} style={styles.text}>
                {currentMessage}{dots}
            </span>
        </div>
    );
};

export default LoadingMessage;
